export const PROJECT_NAME = "Jetsnode"